import ApplicationController from './application_controller';

export default class extends ApplicationController {
  static targets = ['provider', 'practicesProvider', 'switcher', 'providerSource'];

  switchSelect() {
    this.providerTarget.classList.toggle('d-none');
    this.practicesProviderTarget.classList.toggle('d-none');

    // switch provider source
    if (this.providerSourceTarget.value === 'npi_search') {
      this.providerSourceTarget.value = 'practice';
    } else if (this.providerSourceTarget.value === 'practice') {
      this.providerSourceTarget.value = 'npi_search';
    }
  }
}
